<template >
  <slot v-if="state.postSuccess === false">
    <h3>Étape {{ step }} sur {{ maxStep }}</h3>
    <ProgressBar :step="step" :maxStep="maxStep"></ProgressBar>

    <div class="form-container">
      <slot v-if="step === 1">
        <h3>Informations personnelles</h3>
        <FirstStep :v="v1"></FirstStep>
      </slot>

      <slot v-if="step === 2">
        <h3>Informations concernant votre activité professionnelle liée à l'hypnose</h3>
        <SecondStep :v="v2"></SecondStep>
      </slot>

      <slot v-if="step === 3">
        <h3>Votre formation professionnelle</h3>
        <p>
          Pour pouvoir adhérer au SUP-H en tant qu'adhérent PRO, vous devez pouvoir justifier d'au moins une certification de praticien en Hypnose Ericksonienne
          ou d'un praticien en PNL délivrée par une école ou formation reconnue par le SUP-H
        </p>
        <ThirdStep :v="v3"></ThirdStep>
      </slot>

      <slot v-if="step === maxStep">
        <h3>Motivations et Engagements</h3>
        <FourthStep :v="v4"></FourthStep>
      </slot>

      <div class="buttons-navigate">
        <button style="float: left" v-if="step > 1" @click="previousStep()">Précédent</button>
        <button style="float: right" v-if="step < maxStep" @click="nextStep()">Suivant</button>
      </div>
    </div>
    <Toast></Toast>
  </slot>

  <div class="success" v-else>
    <p>{{ state.respMsg }}</p>
  </div>
</template>

<script>
import { ref } from "vue";
import { getStateFormUser, getStateFormProActivity, getStateFormProFormation, getStateFormMotivation } from "../validation";
import FirstStep from "./Forms/FirstStep.vue";
import SecondStep from "./Forms/SecondStep.vue";
import ThirdStep from "./Forms/ThirdStep.vue";
import FourthStep from "./Forms/FourthStep.vue";
import ProgressBar from "./ProgressBar.vue";
import { state } from "../store";
import Toast from "./Toast.vue";

export default {
  name: "Widget",
  components: { FirstStep, SecondStep, ThirdStep, FourthStep, ProgressBar, Toast },

  setup() {
    const step = ref(1);
    const maxStep = 4;
    const compoUser = getStateFormUser();
    const compoProActivity = getStateFormProActivity();
    const compoProFormation = getStateFormProFormation();
    const compoMotivation = getStateFormMotivation();

    const previousStep = () => {
      let divContainer = document.querySelector("#adhesion-pro");

      if (step.value === 1) {
        return step.value;
      }
      else {
        step.value--;
        divContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });

      }
    };

    const nextStep = async () => {
      let divContainer = document.querySelector("#adhesion-pro");

      switch (step.value) {

        case 1:
          await compoUser.validate();

          if (compoUser.v1.value.$invalid) {
            return false;
          }

          step.value++;
          divContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });

          break;

        case 2:
          await compoProActivity.validate();

          if (state.activity.isEmployee) {
            state.activity.apeCode = '';
            state.activity.businessCreation = '';
            state.activity.legalStatus = '';
            state.activity.siret = '';
          }

          if (compoProActivity.v2.value.$invalid) {
            return false;
          }

          step.value++;
          divContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });

          break;

        case 3:
          await compoProFormation.validate();

          if (compoProFormation.v3.value.$invalid) {
            return false;
          }

          step.value++;
          divContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });

          break;

        case 4:
          await compoMotivation.validate();

          if (compoMotivation.v4.value.$invalid) {
            return false;
          }

          step.value++;
          divContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });

          break;
      }
    };

    return { step, maxStep, previousStep, nextStep, state, ...compoUser, ...compoProActivity, ...compoProFormation, ...compoMotivation };
  }
};
</script>

<style scoped lang='scss'>
@import "../scss/variables";
.success {
  background-color: #19c8a6;
  width: 100%;
  padding: 0.5rem;
  text-align: center;
  p {
    color: white;
    margin: 0;
  }
}
.form-container {
  position: relative;
}
h1 {
  text-align: center;
}

.buttons-navigate {
  margin-top: 2rem;

  @include buttonStyle($base-color, 2px solid $base-color, white);
}
</style>
